import { IndicationColumnField } from '@pages/Quotes/IndicationsTable/IndicationColumnField.enum';

export const SortIndicationQueryParam: Record<string, (order: string) => string> = {
  [IndicationColumnField.IndicationNumber]: (order) => `${order}referenceId`,
  [IndicationColumnField.AccountName]: (order) => `${order}customer.name`,
  [IndicationColumnField.CreatedAt]: (order) => `${order}createdAt`,
  [IndicationColumnField.EffectiveDate]: (order) => `${order}effectiveOn`,
  [IndicationColumnField.Offering]: (order) => `${order}offering.insuranceProduct.name`,
  [IndicationColumnField.IndicationAmount]: (order) => `${order}termPremium`,
  [IndicationColumnField.CreatedBy]: (order) => `${order}createdByUser.lastName`,
};
